import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Link from '@material-ui/core/Link';
import { SIGNUP } from '../utils/routes'

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%',
    margin: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  errorMessage: {
    color: 'red'
  },
  button: {
    position: 'relative'
  },
  progress: {
    position: 'absolute',
    color: 'white'
  },
  loginLogo: {
    width: '100%'
  },
  centerLoginForm: {
    position: 'absolute',
    width: theme.sizes.loginFormWidth,
    left: `calc(50% - ${theme.sizes.loginFormWidth / 2}px)`
  },
  signUpLink: {
    textDecoration: "underline"
  }
}));

export default function SignIn({ onSubmit, email, pass, onEmailChange, onPassChange, loading, errorMessage }) {
  const classes = useStyles();

  return (
    <Container component='main' maxWidth='xs' className={classes.centerLoginForm}>
      <CssBaseline />
      <div className={classes.paper}>
        <img src="/loginLogo.png" className={classes.loginLogo} />
        <form className={classes.form} noValidate onSubmit={onSubmit}>
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            id='email'
            label='Email Address'
            name='email'
            type='email'
            autoComplete='email'
            autoFocus
            value={email}
            onChange={onEmailChange}
          />
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            id='password'
            autoComplete='current-password'
            value={pass}
            onChange={onPassChange}
          />
          <Button type='submit' fullWidth className={classes.button} variant='contained' color='primary'>
            Enter
            {loading && <CircularProgress className={classes.progress} size={30} />}
          </Button>
          <Typography className={classes.errorMessage} align='center'>
            {errorMessage}
          </Typography>
        </form>
        <Typography>
          <Link href={SIGNUP} className={classes.signUpLink}>
            New User? Sign Up Here
          </Link>
        </Typography>
      </div>
    </Container>
  );
}
